/**
 * The reminder windows S-D5 offers, plus *never*.
 *
 * Whatever the site actually holds is added to the list if it is not one of
 * these, because `stale_after_days` accepts anything up to 90 — and a select that
 * silently showed "7 days" for a site set to 30 would be a settings screen
 * reporting a value it is about to overwrite.
 */
export const STALE_CHOICES: readonly number[] = [7, 14, 0]

/**
 * The four toggles, with the blast radius the design states beside each one.
 *
 * The codes are `app/seo/gating.CHANGES` and the order is its order — worst
 * blast radius first, which the module's own comment argues: a list that
 * reordered them would put *"we will publish pages you have not read"* under
 * *"we will fix your alt text"*.
 */
export const CHANGES: readonly { code: string; label: string; blast: string }[] = [
  {
    code: 'new_content',
    label: 'Publish new blog posts automatically',
    blast: 'Highest blast radius. New pages appear on your site without you seeing them first.',
  },
  {
    code: 'meta',
    label: 'Change titles and meta descriptions',
    blast: 'Affects how you appear in Google. Reversible, but visible to the public immediately.',
  },
  {
    code: 'internal_links',
    label: 'Add internal links between existing pages',
    blast: "Low risk. Doesn't change your words, only adds links between your own pages.",
  },
  {
    code: 'technical',
    label: 'Fix alt text, schema, and sitemaps',
    blast: 'Invisible to visitors. Purely technical corrections.',
  },
]
